import React from 'react';
import { Totals as ReportTotalsShape } from '../../shapes/report';

class ReportBreakdownTotals extends React.Component {

  render() {
    return (
      <React.Fragment>
        <tr>
          <td><strong>Totals</strong></td>
          <td><strong>{this.props.totals.in}</strong></td>
          <td><strong>{this.props.totals.paid}</strong></td>
          <td><strong>{this.props.totals.net}</strong></td>
          <td><strong>{this.props.totals.tax}</strong></td>
        </tr>
      </React.Fragment>
    )
  }

}

ReportBreakdownTotals.propTypes = {
  totals: ReportTotalsShape.isRequired
};

export default ReportBreakdownTotals;


// WEBPACK FOOTER //
// ./src/views/report/report-breakdown-totals.js